import React from "react";
import classNames from "classnames";
import styles from "./BackdropArea.module.scss";

export interface BackdropAreaProps {
  transparent?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const BackdropArea: React.FC<BackdropAreaProps> = ({ transparent, onClick, className }) => {
  return (
    <div
      className={classNames(styles.root, { [styles.transparent]: transparent }, className)}
      onClick={onClick}
      data-testid="backdrop-area"
    />
  );
};

export default BackdropArea;
